module.exports = __webpack_public_path__ + "static/media/hockey-mask.7025feb9.svg";